import { DeleteWorkScheduleSlotApiResponse } from '@omecare/utils';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import http from '@/utils/http.service';

const deleteById = (id: string) => {
  return http.workScheduleSlots.deleteById(id);
};

const useDeleteAgendaSlotMutation = (): UseMutationResult<
  DeleteWorkScheduleSlotApiResponse,
  Error,
  string
> => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: deleteById,
    onSuccess() {
      toast.success(t('http.delete-work-schedule-slot.success'));
    },
  });
};

export default useDeleteAgendaSlotMutation;
